import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { firstValueFrom, Observable } from 'rxjs';
import { DashboardRequestModel } from 'src/app/models/dashboard/dashboard-request.model';
import { SessionStorageService } from '../session-storage.service';
import { DashboardConfigurationModel } from 'src/app/models/api/dashboard-configuration.model';

/**
 * API client for specificly calls to retrieve Dashboard Items
 */
@Injectable({
  providedIn: 'root'
})
export class DashboardApiClient {

  constructor(private httpClient: HttpClient, private sessionStorageService: SessionStorageService) { }

  configUrlDashboard = environment.apiUrl + "/fe-api/dashboard";
  configUrlOrganisationdocuments = this.configUrlDashboard + "/ForOrganisation";

  /**
   * Retrieves dashboard configuration for logged in user
   * @returns 
   */
  GetConfig(): Observable<DashboardConfigurationModel> {
    return this.httpClient.get<DashboardConfigurationModel>(this.configUrlDashboard + "/configuration");
  }
  /**
   * Load Dashboard Request
   * - Verifies SessionStorage for ALL or YOURS
   * @returns 
   */
  public async loadRequests() {
    let showAllDocsInOrg = this.sessionStorageService.showAllRequestForOrganisation;
    if (showAllDocsInOrg) {
      return await this.getRequestsFromOrg();
    } else {
      return await this.getDashboard();
    }
  }
  private async getDashboard() {
    return firstValueFrom(this.httpClient.get<DashboardRequestModel[]>(this.configUrlDashboard, {}));
  }

  private async getRequestsFromOrg() {
    return firstValueFrom(this.httpClient.get<DashboardRequestModel[]>(this.configUrlOrganisationdocuments, {}));
  }

}
